import { useMemo } from 'react';
import { type Columns } from '../EditableTable';
import { type LeaseTableRecord } from './shared';

const useColumns = (title: string, terms: number[], disabled: boolean, onUpdate: (record: LeaseTableRecord) => void) =>
    useMemo<Columns<LeaseTableRecord>>(() => {
        const results: Columns<LeaseTableRecord> = [
            {
                title,
                dataIndex: 'variantName',
                fixed: true,
                className: 'variant-column',
            },
        ];

        const termColumns = terms.map(term => ({
            title: `${term}`,
            dataIndex: `term${term}`,
            onCell: (record: LeaseTableRecord) => ({
                record,
                dataIndex: `term${term}`,
                isEditable: !disabled,
                onUpdate,
            }),
            className: 'term-column',
        }));

        return [...results, ...termColumns];
    }, [title, terms, onUpdate, disabled]);

export default useColumns;
